import { defineStore } from "pinia";
import { useRoute } from "vue-router";
import router from "../router";
import FeedService from "../services/FeedService.js";

export const useFilteredFeedStore = defineStore("filteredFeed", {
	state: () => ({
		endpoint: document.querySelector("#app").dataset.endpoint || "event",
		items: [],
		filterTitle: document.querySelector("#app").dataset.title || "Filter",
		featuredTitle: "",
		featuredItems: [],
		highlight: null,
		isLoading: true,
		upcomingOnly: true,
		filters: {},
		filterDay: null,
		filterLabels: [],
		filterMode: "single", // single/multi taxonomy option
		isFiltered: false,
		isToggled: false,
		hidden: document.querySelector("#app").dataset.hidden || 0,
		mode: document.querySelector("#app").dataset.mode || "All",

		// Only for main feed
		page: null,
		maxNumPages: null,
		foundPosts: null,
	}),
	actions: {
		async initState() {
			const route = useRoute();
			if (route.query.length) {
				this.isFiltered = true;
			} else {
				if (document.querySelector("#app").dataset.highlight) {
					this.highlight = JSON.parse(document.querySelector("#app").dataset.highlight);
				}
			}

			return route.query;
		},
		setState() {
			router.push({ name: "home", query: this.filters });
			this.fetchItems();
		},
		updateFilters({ taxonomy, term, name }, partOfBatch = false ) {
			if (!this.filters[taxonomy]) {
				this.filters = {
					...this.filters,
					[taxonomy]: this.filterMode == "single" ? term : [term],
				};
			} else {
				if (this.filterMode == "single") {
					if (this.filters[taxonomy] == term) {
						delete this.filters[taxonomy];
					} else {
						this.filters[taxonomy] = term;
					}
				} else {
					if (typeof this.filters[taxonomy] === "string") {
						this.filters[taxonomy] = [this.filters[taxonomy]];
					}
					const index = this.filters[taxonomy].indexOf(term);
					if (index === -1) {
						this.filters[taxonomy].push(term);
					} else {
						this.filters[taxonomy].splice(index, 1);
						if (this.filters[taxonomy].length === 0) {
							delete this.filters[taxonomy];
						}
					}
				}
			}



			delete this.filters._p;

			if( !partOfBatch ){
				this.setState();
			}
		},
		removeDateFilter() {
			// Just for removing date filter
			// Needs to be separate as it's only a single choice
			// Similar to a radio field rather than a checkbox
			delete this.filters.date;
			this.setState();
		},
		async fetchItems() {
			this.isLoading = true;
			try {
				this.filters.mode = this.mode;
				const response = await FeedService.getFeed(this.endpoint, {
					params: this.filters,
				});
				this.items = response.data.items || [];
				this.page = response.data._p;
				this.foundPosts = response.data.found_posts;
				this.maxNumPages = response.data.max_num_pages;
				this.isFiltered = Object.keys(this.filters).length > 0;
				this.filterLabels = response.data.labels;
				this.isLoading = false;
				// console.log( this.foundPosts )
			} catch (error) {
				console.log(error);
			}
		},
		async fetchFeatured() {
			try {
				const response = await FeedService.getFeatured({
					params: { post_type: this.endpoint },
				});
				this.featuredItems = response.data.items;
				this.featuredTitle = response.data.title;
			} catch (error) {
				console.log(error);
			}
		},
		async loadMore() {
			this.isLoading = true;
			this.page++;
			this.filters._p = this.page;
			try {
				const response = await FeedService.getFeed(this.endpoint, {
					params: this.filters,
				});
				this.items = this.items.concat(response.data.items);
				this.isLoading = false;
				// console.log( this.foundPosts )
			} catch (error) {
				console.log(error);
			}
		},
		clearFilters() {
			this.filters = {};
			this.filterLabels = [];
			this.filterDay = null;
			this.setState();
		},
		resetApp() {
			this.clearFilters();
			this.isFiltered = false;
			this.fetchItems();
		},
		navigateNext() {
			if (this.filters._p < this.maxNumPages) {
				this.filters._p++;
			} else {
				this.filters._p = 2;
			}
			this.setState();
		},
		navigatePrev() {
			this.filters._p--;
			this.setState();
		},
		inFilters(term, taxonomy) {
			const filters = this.filters;
			return filters[taxonomy] && filters[taxonomy].includes(term);
		},
	},
	getters: {
		noFilters: (state) => Object.keys(state.filters).length === 0,
		filterMessage: (state) => {
			let msg = [];

			if (state.foundPosts) {
				msg.push(`${state.foundPosts} results`);
			}
			if (state.page !== state.maxNumPages) {
				msg.push(`Page ${state.page} of ${state.maxNumPages}`);
			}
			return state.foundPosts ? msg.join(" ") : null;
		},
		hasSingleTaxonomy: (state) => {
			return state.endpoint === "post";
		},
		hasMorePages: (state) => {
			return state.page < state.maxNumPages;
		},
	},
});
